import React from 'react'
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm';
import HighSet from "@/containers/common/highSet";
const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
let componentName = 'interviewQuestion'

const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '岗位',
    name: 'posListIds',
    dataIndex: 'posListIds',
    searchItem: {
      ...positionConfig,
      diy: WizTableForm
    }
  },
  {
    title: '品牌',
    name: 'orgListIds',
    dataIndex: 'orgListIds',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm
    }
  },
  {
    title: '岗位',
    name: 'positionNames',
    dataIndex: 'positionNames',
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'orgNames',
    dataIndex: 'orgNames',
    tableItem: {}
  },
  {
    title: '试题导入时间',
    name: 'importTime',
    dataIndex: 'importTime',
    tableItem: {}
  }
]

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['importQuestions','advancedSet'],
        rowOperateView: [
          {
            key: 'importQuestions',
            custom: true,
            params: { children: '导入试题' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/interview/question/questionImport'
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{ record: {...e.record,status:0}, bizType: 53 }}
                               changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            }
          },
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
